// Project-level building authoring data.
// Devkit can still override these values through localStorage while authoring, but gameplay reads
// through these helpers so the source of truth can move into this file per building.

export const BUILDING_CONFIG = {
  food: { asset: 'uploads/food-baked-6a140e3c.glb', front: 0, sink: 0, footprint: [4, 4] },
  pizza: { asset: 'uploads/pizza-baked.glb', front: 0, sink: 0, footprint: [4, 4] },
  candy: { asset: 'uploads/candy-baked-398c3e5b.glb', front: 0, sink: 0, footprint: [4, 4] },
  drink: { asset: 'uploads/drinks-baked.glb', front: 0, sink: 0, footprint: [4, 4] },
  coffee: { asset: 'uploads/coffee-baked.glb', front: 0, sink: 0, footprint: [9, 9] },
  icecream: { asset: 'uploads/icecream.glb', front: 0, sink: 0, footprint: [5, 6] },
  toilet: { asset: 'uploads/toilet-baked.glb', front: 0, sink: 0, footprint: [4, 4] },
  restroom: { asset: 'uploads/restrooms-baked.glb', front: 0, sink: 0, footprint: [7, 8] },
  info: { asset: 'uploads/infokiosk-baked.glb', front: 0, sink: 0, footprint: [7, 7] },
  vet: { front: 0, sink: 0, footprint: [4, 4] },
  balloon: { asset: 'uploads/balloon-baked.glb', front: 0, sink: 0, footprint: [5, 6] },
  shop: { asset: 'uploads/giftshop-baked.glb', front: 0, sink: 0, footprint: [6, 7] },
  playground: { asset: 'uploads/playground-baked.glb', front: 0, sink: 0, footprint: [11, 12] },
  museum: { asset: 'uploads/museum-baked.glb', front: 0, sink: 0, footprint: [7, 8] },
  entry: { front: 0, sink: 0, footprint: [1, 1] },
};

export const BUILDING_CONFIG_STORAGE_KEY = 'zoo_dev_config';
let buildingConfigInitialized = false;

function readStoredBuildingConfig() {
  try { return JSON.parse(localStorage.getItem(BUILDING_CONFIG_STORAGE_KEY) || '{}'); }
  catch { return {}; }
}

function baseConfig() {
  const fronts = {}, sink = {}, fp = {};
  Object.entries(BUILDING_CONFIG).forEach(([type, cfg]) => {
    if (cfg.front != null) fronts[type] = cfg.front;
    if (cfg.sink != null) sink[type] = cfg.sink;
    if (cfg.footprint) fp[type] = cfg.footprint;
  });
  return { fronts, sink, fp };
}

export function initBuildingConfigGlobals() {
  if (buildingConfigInitialized) return;
  const base = baseConfig();
  const cfg = readStoredBuildingConfig();
  window.__FRONTS = { ...base.fronts, ...(window.__FRONTS || {}), ...(cfg.fronts || {}) };
  window.__SINK = { ...base.sink, ...(window.__SINK || {}), ...(cfg.sink || {}) };
  window.__FP = { ...base.fp, ...(window.__FP || {}), ...(cfg.fp || {}) };
  buildingConfigInitialized = true;
}

export function getBuildingConfigSnapshot() {
  initBuildingConfigGlobals();
  return {
    fronts: { ...window.__FRONTS },
    sink: { ...window.__SINK },
    fp: { ...window.__FP },
  };
}

export function persistBuildingConfigSnapshot(config = getBuildingConfigSnapshot()) {
  localStorage.setItem(BUILDING_CONFIG_STORAGE_KEY, JSON.stringify(config));
}

export function applyBuildingConfigSnapshot(config, persist = false) {
  if (!config) return;
  initBuildingConfigGlobals();
  if (config.fronts) Object.assign(window.__FRONTS, config.fronts);
  if (config.sink) Object.assign(window.__SINK, config.sink);
  if (config.fp) Object.assign(window.__FP, config.fp);
  if (persist) persistBuildingConfigSnapshot(getBuildingConfigSnapshot());
}

export function getBuildingFront(type) {
  initBuildingConfigGlobals();
  if (window.__FRONTS[type] != null) return window.__FRONTS[type];
  return BUILDING_CONFIG[type]?.front ?? 0;
}

export function getBuildingSink(type) {
  initBuildingConfigGlobals();
  if (window.__SINK[type] != null) return window.__SINK[type];
  return BUILDING_CONFIG[type]?.sink ?? 0;
}

export function getBuildingFootprint(type, fallback = [1, 1]) {
  initBuildingConfigGlobals();
  return window.__FP[type] || BUILDING_CONFIG[type]?.footprint || fallback;
}

export function getBakedBuildingAssets() {
  return Object.fromEntries(
    Object.entries(BUILDING_CONFIG)
      .filter(([, cfg]) => cfg.asset)
      .map(([type, cfg]) => [type, cfg.asset])
  );
}

export function setMeasuredBuildingFootprint(type, footprint) {
  initBuildingConfigGlobals();
  window.__FP[type] = footprint;
}
